"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTypingIndicatorVisible = useTypingIndicatorVisible;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _TypingAnimation = _interopRequireDefault(require("./Assets/TypingAnimation"));

var _useLastTypingAt3 = _interopRequireDefault(require("../hooks/useLastTypingAt"));

var _useLocalize = _interopRequireDefault(require("../hooks/useLocalize"));

var _useStyleOptions3 = _interopRequireDefault(require("../hooks/useStyleOptions"));

var _useStyleSet3 = _interopRequireDefault(require("../hooks/useStyleSet"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function useTypingIndicatorVisible() {
  var _useLastTypingAt = (0, _useLastTypingAt3.default)(),
      _useLastTypingAt2 = _slicedToArray(_useLastTypingAt, 1),
      lastTypingAt = _useLastTypingAt2[0];

  var _useStyleOptions = (0, _useStyleOptions3.default)(),
      _useStyleOptions2 = _slicedToArray(_useStyleOptions, 1),
      typingAnimationDuration = _useStyleOptions2[0].typingAnimationDuration;

  var last = Math.max(Object.values(lastTypingAt));
  var typingAnimationTimeRemaining = last ? Math.max(0, typingAnimationDuration - Date.now() + last) : 0;

  var _useState = (0, _react.useState)(typingAnimationTimeRemaining > 0),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  (0, _react.useEffect)(function () {
    var timeout;

    if (typingAnimationTimeRemaining > 0) {
      setValue(true);
      timeout = setTimeout(function () {
        return setValue(false);
      }, typingAnimationTimeRemaining);
    } else {
      setValue(false);
    }

    return function () {
      return clearTimeout(timeout);
    };
  }, [typingAnimationTimeRemaining]);
  return [value];
}

var TypingIndicator = function TypingIndicator() {
  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      typingIndicatorStyleSet = _useStyleSet2[0].typingIndicator;

  var _useTypingIndicatorVi = useTypingIndicatorVisible(),
      _useTypingIndicatorVi2 = _slicedToArray(_useTypingIndicatorVi, 1),
      showTyping = _useTypingIndicatorVi2[0];

  var animationAriaLabel = (0, _useLocalize.default)('TypingIndicator');
  return showTyping && _react.default.createElement("div", {
    className: typingIndicatorStyleSet
  }, _react.default.createElement(_TypingAnimation.default, {
    "aria-label": animationAriaLabel
  }));
};

var _default = TypingIndicator;
exports.default = _default;